import { render, staticRenderFns } from "./base_performance.vue?vue&type=template&id=b42feee2&scoped=true"
import script from "./base_performance.vue?vue&type=script&lang=ts"
export * from "./base_performance.vue?vue&type=script&lang=ts"
import style0 from "./base_performance.vue?vue&type=style&index=0&id=b42feee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42feee2",
  null
  
)

export default component.exports